import { render, staticRenderFns } from "./DictSort.vue?vue&type=template&id=e91633f0&scoped=true&"
import script from "./DictSort.vue?vue&type=script&lang=js&"
export * from "./DictSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91633f0",
  null
  
)

export default component.exports